import { cn } from "@/utils";

/** Shared hover surface for in-app transfer drop targets (chat, workspace, folders). */
export const transferDropTargetActiveClassName =
  "bg-rust/5 ring-2 ring-inset ring-rust/25";

/**
 * Invalid drop (e.g. canvas onto a folder path, wrong kind for this surface).
 * A muted, grayed-out disabled ring — matches the grayed "can't drop here" pill
 * so the surface and the pill speak the same language.
 */
export const transferDropTargetInvalidClassName =
  "bg-foreground/[0.03] ring-2 ring-inset ring-foreground/20";

/** Favorites rail — amber star tint (matches row Star menu items). */
export const transferDropTargetFavoritesActiveClassName =
  "bg-amber-500/10 ring-2 ring-inset ring-amber-500/30";

export function cnTransferDropTargetSurface({
  isOver,
  disallowed = false,
  className,
}: {
  isOver: boolean;
  disallowed?: boolean;
  className?: string;
}): string {
  return cn(
    "min-h-0 rounded-md transition-colors duration-150",
    isOver && !disallowed && transferDropTargetActiveClassName,
    isOver && disallowed && transferDropTargetInvalidClassName,
    className,
  );
}
